// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"160":"d62267cb","463":"feec1194","584":"9c9cb656","792":"36841bd2","920":"96bfde7a"}[chunkId] + ".js";
};